<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="close()">&#xe03e;</button>
    <h2>{{(data.title ? data.title : 'Msg.Alert') | translate}}</h2>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        @if (!data.isHtml) {
          <div class="cald_content">{{data.content | translate}}</div>
        }
        @if (data.isHtml) {
          <div class="cald_content" [innerHTML]='data.content'></div>
        }
        @if (data.additionalContent) {
          <div class="cald_content cald_additional_content">{{data.additionalContent}}</div>
        }
      </div>
    </div>
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" (click)="close()">{{'Msg.OK' | translate}}</button>
  </div>
</div>